// import React, { useEffect, useState } from "react";
// import { useNavigate, useParams } from "react-router-dom";
// import axios from "axios";
// import { API_BASE_URL } from "../../../../utils/index";

// import { useAuthHeaders } from "../../../../components/Token";
// import Swal from "sweetalert2/dist/sweetalert2.js";
// import { Modal, Button, Form } from "react-bootstrap";
// import TextField from "@mui/material/TextField";
// import FormLabel from "@mui/material/FormLabel";
// function EditSubCategory( show, handleClose) {
//   const { _id } = useParams();
//   const [subcategoryname, setNewSubCategoryName] = useState("");
//   const navigate = useNavigate();
//   const [categories, setCategories] = useState("");
//   const headers = useAuthHeaders();

//   useEffect(() => {
//     axios
//       .get(`${API_BASE_URL}/singlesubcategory/${_id}`, {
//         headers,
//       })
//       .then((response) => {
//         console.log(response.data.data, "???????????????????????????//");
//         setNewSubCategoryName(response.data.data.subcategoryname);
//         setCategories(response.data.data.category.categoryname);
//       })
//       .catch((error) => {
//         console.log(error);
//       });
//   }, []);

//   const handleSave = (e) => {
//     e.preventDefault();
//     const data = { subcategoryname: subcategoryname };
//     axios
//       .put(`${API_BASE_URL}/updatesubcategory/${_id}`, data, {
//         headers,
//       })
//       .then((response) => {
//         console.log("response :", response);
//         navigate("/subCategory");
//       })
//       .catch((error) => {
//         console.error("Error updating category:", error);
//         Swal.fire({
//           icon: "error",
//           title: "Oops...",
//           text: error.response.data.error,
//         });
//       });
//   };

//   return (
//     <Modal show={show} onHide={handleClose}>
//       <Modal.Header closeButton>
//         <Modal.Title className="text-center">
//           <h5 className="text-center ms-5">Edit Property Type</h5>
//         </Modal.Title>
//       </Modal.Header>
//       <Form onSubmit={handleSave}>
//         <Modal.Body>
//           <Form.Group controlId="formCategoryName">
//             <div className="m-auto">
//               <FormLabel>Change prpoperty type Name:</FormLabel>
//               <p className="mx-2">{categories}</p>

//               <div className="d-flex">
//                 <label htmlFor="name" className="fs-6 fw-bold">
//                   Change Sub Category Name:
//                 </label>
//                 <br />
//                 <p className="mx-2">{subcategoryname}</p>{" "}
//               </div>
//               <TextField
//                 type="text"
//                 id="name"
//                 value={subcategoryname}
//                 onChange={(e) => setNewSubCategoryName(e.target.value)}
//                 fullWidth
//               />
//             </div>
//           </Form.Group>
//         </Modal.Body>
//         <Modal.Footer>
//           <button
//             type="submit"
//             style={{ color: "black" }}
//             className="btn btn-warning"
//           >
//             Save
//           </button>
//           <button className="btn btn-primary me-auto" path="/category">
//             Cancel
//           </button>
//         </Modal.Footer>
//       </Form>
//     </Modal>
//   );
// }

// export default EditSubCategory;
// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import axios from "axios";
// import { API_BASE_URL } from "../../../../utils/index";
// import { useAuthHeaders } from "../../../../components/Token";
// import Swal from "sweetalert2/dist/sweetalert2.js";
// import { Modal, Button, Form } from "react-bootstrap";
// import TextField from "@mui/material/TextField";
// import FormLabel from "@mui/material/FormLabel";
// import MenuItem from '@mui/material/MenuItem';

// function EditSubCategory({ show, handleClose, categoryId,fetchCategories ,handleSave}) {
//   const [category, setCategory] = useState("");
//   const [subcategoryname, setNewSubCategoryName] = useState("");
//   const [categories, setCategories] = useState("");
//   const headers = useAuthHeaders();
//   const navigate = useNavigate();

//   useEffect(() => {
//     if (categoryId) {
//       axios
//         .get(`${API_BASE_URL}/singlesubcategory/${categoryId}`, { headers })
//         .then((response) => {
//           setNewSubCategoryName(response.data.data.subcategoryname);
        
//           console.log(response.data.data,"EEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEe")
//         })
//         .catch((error) => {
//           console.log(error);
//         });
//     }
//     axios
//     .get(`${API_BASE_URL}/getallcategory`, { headers })
//     .then((response) => {
//       console.log(response.data.data, "API Response");
//       if (response.data && Array.isArray(response.data.data)) {
//         setCategories(response.data.data);
//       } else {
//         console.error("Unexpected response structure:", response.data.data);
//       }
//     })
//     .catch((error) => {
//       console.error("Error fetching category data:", error);
//     });
    
      
//         const data = { subcategoryname: subcategoryname };
//         axios
//           .put(`${API_BASE_URL}/updatesubcategory/${categoryId}`, data, { headers })
//           .then((response) => {
//             navigate("/subCategory");
//           })
//           .catch((error) => {
//             console.error("Error updating category:", error);
//             Swal.fire({
//               icon: "error",
//               title: "Oops...",
//               text: error.response.data.error,
//             });
//           });
//         }, [categoryId, headers]);

//   return (
//     <Modal show={show} onHide={handleClose}>
//       {/* <Modal.Header className="text-center">
//         <Modal.Title className="">
//           <h5 className="m-auto fw-bold">Edit Property Type</h5>
//         </Modal.Title>
//       </Modal.Header> */}
//       <Modal.Header className="text-center">
//         <Modal.Title className="m-auto fw-bold ">
//           Edit Property Type
//         </Modal.Title>
//       </Modal.Header>
//       <Form onSubmit={handleSave}>
//         <Modal.Body>
//           <Form.Group controlId="formCategoryName">
//             <div className="">
//               <TextField
//                 select
//                 label="Select a Type"
//                 onChange={(e) => setCategory(e.target.value)}
//                 value={category}
//                 required
//                 className="w-100"
//               >
//                 {categories.length > 0 &&
//                   categories.map((option) => (
//                     <MenuItem key={option._id} value={option._id}>
//                       {option.categoryname}
//                     </MenuItem>
//                   ))}
//               </TextField>
//             </div>
//             <div className="m-auto">
//               <div className="d-flex">
//                 <label htmlFor="name" className="fs-6 fw-bold">
//                   Change Sub Category Name:
//                 </label>
//                 <br />
//                 <p className="mx-2">{subcategoryname}</p>
//               </div>
//               <TextField
//                 type="text"
//                 id="name"
//                 value={subcategoryname}
//                 onChange={(e) => setNewSubCategoryName(e.target.value)}
//                 fullWidth
//               />
//             </div>
//           </Form.Group>
//         </Modal.Body>
//         <Modal.Footer className="justify-content-center">
//           <button
//             type="submit"
//             style={{ color: "black" }}
//             className="btn btn-warning"
//           >
//             Save
//           </button>
//           <button className="btn btn-primary " onClick={handleClose}>
//             Cancel
//           </button>
//         </Modal.Footer>
//       </Form>
//     </Modal>
//   );
// }

// export default EditSubCategory;
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { API_BASE_URL } from "../../../../utils/index";
import { useAuthHeaders } from "../../../../components/Token";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { Modal, Button, Form } from "react-bootstrap";
import TextField from "@mui/material/TextField";
import MenuItem from '@mui/material/MenuItem';

function EditSubCategory({ show, handleClose, categoryId, fetchCategories }) {
  const [category, setCategory] = useState("");
  const [subcategoryname, setNewSubCategoryName] = useState("");
  const [categories, setCategories] = useState([]);
  const headers = useAuthHeaders();
  const navigate = useNavigate();

  useEffect(() => {
    if (categoryId) {
      axios
        .get(`${API_BASE_URL}/singlesubcategory/${categoryId}`, { headers })
        .then((response) => {
          const { subcategoryname, category } = response.data.data;
          setNewSubCategoryName(subcategoryname);
          setCategory(category._id); // Assuming `category` is an object with an `_id` field
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [ headers]);

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/getallcategory`, { headers })
      .then((response) => {
        if (response.data && Array.isArray(response.data.data)) {
          setCategories(response.data.data);
        } else {
          console.error("Unexpected response structure:", response.data.data);
        }
      })
      .catch((error) => {
        console.error("Error fetching category data:", error);
      });
  }, [headers]);

  const handleFormSubmit = (event) => {
    event.preventDefault();

    const data = { subcategoryname, category };

    axios
      .put(`${API_BASE_URL}/updatesubcategory/${categoryId}`, data, { headers })
      .then((response) => {
       
        handleClose();
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Subcategory updated successfully!",
        });
      })
      .catch((error) => {
        console.error("Error updating subcategory:", error);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: error.response?.data?.error || "Something went wrong!",
        });
      });
  };

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header className="text-center">
        <Modal.Title className="m-auto fw-bold">
          Edit Subcategory
        </Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleFormSubmit}>
        <Modal.Body>
          <Form.Group controlId="formCategoryName">
            <div className="">
              <TextField
                select
                label="Select a Category"
                onChange={(e) => setCategory(e.target.value)}
                value={category}
                required
                className="w-100"
              >
                {categories.length > 0 &&
                  categories.map((option) => (
                    <MenuItem key={option._id} value={option._id}>
                      {option.categoryname}
                    </MenuItem>
                  ))}
              </TextField>
            </div>
            <div className="m-auto">
              <div className="d-flex">
                <label htmlFor="name" className="fs-6 fw-bold">
                  Change Subcategory Name:
                </label>
                <br />
                <p className="mx-2">{subcategoryname}</p>
              </div>
              <TextField
                type="text"
                id="name"
                value={subcategoryname}
                onChange={(e) => setNewSubCategoryName(e.target.value)}
                fullWidth
              />
            </div>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer className="justify-content-center">
          <Button type="submit" className="btn btn-warning">
            Save
          </Button>
          <Button className="btn btn-primary" onClick={handleClose}>
            Cancel
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}

export default EditSubCategory;
